<template>
  <div class="formc">
    <!-- 列表 -->
    <template v-if="!isEdit">
      <div class="formc-con">
        <el-table class="el-table-s1" :data="paginationData" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" border>
          <el-table-column label="股东" prop="invname" width="113" />
          <el-table-column label="认缴出资额(万元)" prop="lisubconam" width="108" />
          <el-table-column label="认缴出资时间" prop="subcondate" width="108">
            <template #default="{ row }">{{ dateCnStr(row.subcondate) }}</template>
          </el-table-column>
          <el-table-column label="认缴出资方式" prop="subconform" width="108">
            <template #default="{ row }">{{ getLabel(row.subconform, subconformOptions) }}</template>
          </el-table-column>
          <el-table-column label="实缴出资额(万元)" prop="liacconam" width="108" />
          <el-table-column label="实缴出资时间" prop="accondate" width="108">
            <template #default="{ row }">{{ dateCnStr(row.accondate) }}</template>
          </el-table-column>
          <el-table-column label="实缴出资方式" prop="acconform" width="108">
            <template #default="{ row }">{{ getLabel(row.acconform, subconformOptions) }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="{ row, $index }">
              <el-button style="color: #cfa95e" link @click="edit($index)">修改</el-button>
              <el-button style="color: #cfa95e" link @click="del($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="formc-pagination" v-show="data.length > 0">
          <el-pagination
            background
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :page-sizes="[5, 10, 20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="data.length"
          />
        </div>
      </div>

      <div class="formc-btn">
        <el-button type="primary" color="#d1ab62" size="large" @click="edit(-1)">新增</el-button>
        <el-button type="primary" color="#d1ab62" size="large" @click="emits('emit', 'gotoPage', 'center')">返回</el-button>
      </div>
    </template>

    <!-- 新增 -->
    <template v-else>
      <div class="formc-con">
        <el-form :model="formData" :rules="rules" ref="elFormRef" inline-message scroll-to-error :scroll-into-view-options="{ behavior: 'smooth', block: 'center' }">
          <table class="el-table-s2">
            <tbody>
              <tr>
                <td class="table-label" width="160" height="40">股东</td>
                <td>
                  <el-form-item prop="invname">
                    <el-input v-model.trim="formData.invname" />
                  </el-form-item>
                </td>
                <td class="table-label" width="160" height="40">认缴出资额(万元)</td>
                <td>
                  <el-form-item prop="lisubconam">
                    <el-input v-model.trim="formData.lisubconam" />
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td class="table-label" width="160" height="40">认缴出资时间</td>
                <td>
                  <el-form-item prop="subcondate">
                    <el-date-picker style="width: 100%" v-model="formData.subcondate" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择时间" />
                  </el-form-item>
                </td>
                <td class="table-label" width="160" height="40">认缴出资方式</td>
                <td>
                  <el-form-item prop="subconform">
                    <el-select v-model="formData.subconform">
                      <el-option v-for="(item, index) of subconformOptions" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td class="table-label" width="160" height="40">实缴出资额(万元)</td>
                <td>
                  <el-form-item prop="liacconam">
                    <el-input v-model.trim="formData.liacconam" />
                  </el-form-item>
                </td>
                <td class="table-label" width="160" height="40">实缴出资时间</td>
                <td>
                  <el-form-item prop="accondate">
                    <el-date-picker style="width: 100%" v-model="formData.accondate" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择时间" />
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td class="table-label" width="160" height="40">实缴出资方式</td>
                <td colspan="3">
                  <el-form-item prop="acconform">
                    <el-select v-model="formData.acconform">
                      <el-option v-for="(item, index) of subconformOptions" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form>
      </div>

      <div class="formc-btn">
        <el-button type="primary" color="#d1ab62" size="large" @click="save">保存</el-button>
        <el-button type="primary" color="#d1ab62" size="large" @click="back">返回</el-button>
      </div>
    </template>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import { subconformOptions, getLabel } from "./utils.js";
import { ElMessageBox } from "element-plus";

const props = defineProps({
  data: {
    type: Array,
    defaults() {
      return [];
    },
  },
});

const isEdit = ref(false);

const elFormRef = ref();

const data = ref([]);

const rulesConfig = { required: true, trigger: ["blur", "change"], message: "不能为空" };

const rules = ref({
  invname: [rulesConfig],
  lisubconam: [rulesConfig],
  subcondate: [rulesConfig],
  subconform: [rulesConfig],
  liacconam: [rulesConfig],
  accondate: [rulesConfig],
  acconform: [rulesConfig],
});

const editIndex = ref(-1);

const formData = ref({});

const save = () => {
  elFormRef.value.validate((isValid) => {
    if (isValid) {
      if (editIndex.value > -1) {
        data.value.splice(editIndex.value, 1, formData.value);
      } else {
        data.value.push(formData.value);
      }

      emits("emit", "submit", data.value);
      back();
    }
  });
};

const edit = (index) => {
  if (index > -1) {
    // 实际index
    const dataIndex = (currentPage.value - 1) * pageSize.value + index;
    editIndex.value = dataIndex;
    formData.value = cloneDeep(data.value[dataIndex]);
  }

  isEdit.value = true;
};

const del = (index) => {
  // 实际index
  const dataIndex = (currentPage.value - 1) * pageSize.value + index;
  ElMessageBox.confirm("是否确认删除该企业信息？", "提示", {
    confirmButtonText: "是",
    cancelButtonText: "否",
    type: "warning",
  })
    .then(() => {
      data.value.splice(dataIndex, 1);
      emits("emit", "submit", data.value);
    })
    .catch(() => {});
};

const back = () => {
  isEdit.value = false;
  formData.value = {};
  editIndex.value = -1;
};

const emits = defineEmits(["emit"]);

function dateCnStr(str) {
  if (dayjs(str).$d != "Invalid Date") {
    return dayjs(str).format("YYYY年MM月DD日");
  }
}

const currentPage = ref(1);
const pageSize = ref(5);

const paginationData = computed(() => {
  if (data.value.length == 0) {
    return data.value;
  }

  return chunkArrayWithArrayFrom(data.value, pageSize.value)[currentPage.value - 1];
});

function chunkArrayWithArrayFrom(array, size) {
  return Array.from({ length: Math.ceil(array.length / size) }, (v, i) => array.slice(i * size, i * size + size));
}

onMounted(() => {
  data.value = cloneDeep(props.data);
});
</script>

<style lang="scss" scoped>
.formc {
}
</style>
